import {Component, Fragment, h} from 'preact';
import DeviceBadInfo from "./DeviceBadInfo";
import {
	formatPrice,
	getDateOfPrevPeriod,
	calcDaysBetweenDates,
	getDateFromString,
	formatDate,
	formatPriceWithSymbol,
	calcDaysBetweenDateStrings
} from "../../tools";
import AccountDetails from "./AccountDetails";
import AccountDetailsChart from "./AccountDetailsChart";
import DeviceList from "./DeviceList";
import Warning from "./Warning";

class ContractInfo extends Component
{
	constructor(props) {
		super(props);
		this.state = {
			canEnterMeterReadings: props.canEnterMeterReadings,
			enterUrl: props.enterUrl,
			contract: props.contract,
			account: props.account,
			formParams: props.formParams,
			amounts: props.amounts,
			createOrderForContract: props.createOrderForContract,
			onChangeAmountInput: props.onChangeAmountInput,
			details: props.details,
			devices: props.devices
		}
	}

	render(props, state, context)
	{

		const {account, contract, details, devices, amounts, createOrderForContract, enterUrl, canEnterMeterReadings, onChangeAmountInput} = state;

		let sumToPayValue = details.sumToPayValue,
			sumToPayCalc = details.sumToPayCalc,
			sumToPayStand = details.sumToPayStand,
			fine = details.fine;

		let detailsDataByValues = details.sumToPayValue > 0 ? this.makeDetailsInfoByValues(details, devices).detailsData : [];
		let detailsTotalByValues = details.sumToPayValue > 0 ? this.makeDetailsInfoByValues(details, devices).detailsTotal : [];
		let dataCalc = details.sumToPayCalc > 0 ? this.makeDetailsInfoCalc(details, devices) : [];
		// warnings for calc method
		const warnings = state.formParams.warnings;
		let showWarning = false;
		let warningTitle = null;
		let warningContent = null;

		if(warnings) {
			if (sumToPayCalc > 0) {
				showWarning = true;
				warningTitle = warnings.calulateDebts.warningTitle;
				warningContent = warnings.calulateDebts.warningContent;
			}
		} else
		{
			showWarning = false;
		}

		const formParams = state.formParams;
		const detailsInfo = [
			{
				method: "value",
				title: "По показаниям",
				amount: sumToPayValue, // details.sumToPayCalc (details.sumToPayValue)
				type: detailsDataByValues.length > 0 ? 'extended' : 'default',
				data: detailsDataByValues,
				total: detailsTotalByValues,
			},
			{
				method: "calc",
				title: "Расчетным способом",
				amount: sumToPayCalc,
				type: dataCalc.length > 0 ? 'extended' : 'default',
				data: dataCalc,
			},
			{
				method: "norm",
				title: "Норматив / среднесуточное",
				amount: sumToPayStand,
				type: 'default',
				data: [],
			},
			{
				method: "fine",
				title: "Пеня",
				amount: fine,
				type: 'default',
				data: [],
			}
		]
		const lastPay = {
			value: details.prevPaySum,
			date: details.prevDatePay,
		}

		var devicesFormatted = [];

		if(devices && devices.length > 0) {
			devicesFormatted = this.makeDevicesInfo(devices, lastPay);
		}
		let enterMeterDisabledButtonText = 'Прибор учета неисправен или отсутствует';
		if(!canEnterMeterReadings)
		{
			for(let device of devices)
			{
				if(device.state == 1)
				{
					enterMeterDisabledButtonText = 'Показания были внесены сегодня';
					break;
				}
			}
		}

		return (
			<div className={"debt-table-item debt-table-item_details debt-table__item " + (!formParams.allowedPayment ? 'debt-table-item-2_not-padding':'')}>
				<div className="debt-table-item-2__row">
					<div className="debt-table-item-2__col debt-table-item-2__col_align_start">
						<a className="button button-secondary button-secondary_border button-secondary_arrow_back" href="/">Назад к списку адресов</a>
					</div>
					<div className="debt-table-item-2__col">
						<Fragment>
							<div className="debt-table-item-2__button-container">
								<a className="button-secondary button-secondary_border-blue" href={"/accounts-details/?f%5BprodType%5D="+ contract.prodType +"&f%5BaccountId%5D=" + account.id + "&full=Y"}>Подробнее</a>
								<button
									className={amounts.total > 0 ? "button-primary button-primary_bgc_brand-2" : "button-primary button-primary_bgc_brand-2 disabled"}
									//onClick={() => createOrderForContract(account.id, contract.id)}
									disabled={amounts.total <= 0}
									data-modal-url={amounts.total > 0 ? `/order/contract-pay/?contractId=${contract.id}&accountId=${account.id}`:''}
								>
									Оплатить {formatPriceWithSymbol(amounts.total)}
								</button>
								{!!canEnterMeterReadings && (
									<button className="button-primary button-primary_pdv_sm debt-table-item-2__counter-btn" data-modal-url={enterUrl} onClick={() => {window.reachGoal('meters')}}>
										<span className="button-primary__text">Передать показания</span><span className="button-primary__icon button-primary__icon_sz_sm js__tooltip" title="Передача показаний необходима для точного расчета задолженности"></span>
									</button>
								)}
								{!canEnterMeterReadings && (
									<span className="button-secondary button-secondary_border button-secondary_no-device disabled">{enterMeterDisabledButtonText}</span>
								)}
							</div>
						</Fragment>
					</div>

				</div>
				<div className="debt-table-item__main-info row">
					<div className="col col-12 col-lg-4">
						<AccountDetailsChart details={detailsInfo} amounts={amounts}/>
						{showWarning && <Warning title={warningTitle} content={warningContent} />}
					</div>
					<div className="col col-12 col-lg-8">
						<AccountDetails details={detailsInfo}/>
						<DeviceList devices={devicesFormatted} formParams={formParams}/>
					</div>
				</div>
				<DeviceBadInfo device={null} contract={contract} account={account} formParams={formParams}/>
			</div>
		)
	}

	calcSumForDevices(devices, field) {
		let sum = 0;
		for(let device of devices) {
			sum += device[field];
		}
		return sum;
	}

	concatValuesForDevices(devices, field) {
		let result = '';
		let i = 0;
		for(let device of devices) {
			result += 'п.у №' + device.serial.toString() + ': ' + device[field].toString() + i < devices.length - 1  && devices.length > 1 ? '; ' : '' ;
			i++;
		}
		return result;
	}

	makeDevicesInfo(devices, lastPay = null) {
		let devicesInfo = [];
		var date = new Date();
		devices.map(device => {
			let newItem = {
				id: device.serial,
				status: device.state,
				lastValue: device.val2,
				source: device.source2,
			};
			let daysWithoutValues = calcDaysBetweenDateStrings(device.date2, formatDate(date))
			let data = [
				{
					name: "lastValue",
					title: "Последние показания",
					value: device.val2,
					additional: 'от ' + device.date2,
				},
				{
					name: "daysWithoutValues",
					title: "Количество дней без показаний",
					value: daysWithoutValues,
				},
				{
					name: "source",
					title: "Источник",
					value: device.source2,
				},
			];
			if (lastPay) {
				let lastPayInfo = {
					name: "lastPay",
					title: "Последняя оплата",
					value: lastPay.value + " ₽",
					additional: 'от ' + lastPay.date,
				};
				data.push(lastPayInfo);
			}
			newItem.data = data;
			devicesInfo.push(newItem);
		});
		return devicesInfo;
	}

	makeDetailsInfoCalc(details, devices) {

		let date = new Date(), y = date.getFullYear(), m = date.getMonth();
		let lastDayOfPeriod = getDateOfPrevPeriod();

		let sumVolCalc = this.calcSumForDevices(devices, 'rvol');
		let sumAmountCalc = this.calcSumForDevices(devices, 'rsum');

		let dataCalc = [];
		for(let device of devices) {
			if (device.state != 1) {
				continue;
			}
			let daysWithoutValues = calcDaysBetweenDates(getDateFromString(device.date2), lastDayOfPeriod);
			let averageDailyConsumption = 0;
			if(daysWithoutValues > 0) {
				averageDailyConsumption = (parseFloat(sumVolCalc)/daysWithoutValues).toFixed(2);
			}
			let dataCalcItem = [
				{
					field: "Показание текущее",
					value: device.val2,
				},
				{
					field: "Дата",
					value: device.date2,
				},
				{
					field: "Источник",
					value: device.source2,
				},
				{
					field: "Количество дней без показаний на конец расчетного периода",
					value: daysWithoutValues + " дней",
					additionalClass: 'text-color_orange',
				},
				{
					field: "Среднесуточное потребление КВт/ч",
					value: averageDailyConsumption + " кВтч",
				},
				{
					field: "Расчетное потребление с " + device.date2 + " по " + formatDate(lastDayOfPeriod),
					value: sumVolCalc + " кВтч",
				},
				{
					field: "Расчетное начисление",
					value: parseFloat(sumVolCalc) + " * " + device.taxacur + " = " + formatPriceWithSymbol(parseFloat(sumAmountCalc)),
				},
			];

			dataCalc.push(
				{
					serial: device.serial,
					data: dataCalcItem,
				}
			);
		}

		return dataCalc;
	}

	makeDetailsInfoByValues(details, devices) {

		let sumForDevices = this.calcSumForDevices(devices, 'sum');
		let totalSum = details.sumToPayValue;
		let sumForPrevValues = totalSum - sumForDevices;
		let detailsData = [];

		for(let device of devices) {
			if (device.state != 1) {
				continue;
			}
			let dataValueItem = [
				{
					field: "Показание текущее",
					value: device.val2,
				},
				{
					field: "Дата",
					value: device.date2,
				},
				{
					field: "Источник",
					value: device.source2,
				},
				{
					field: "Показания предыдущие",
					value: device.val1,
				},
				{
					field: "Дата предыдущих показаний",
					value: device.date1,
				},
				{
					field: "Источник предудущих показаний",
					value: device.source1,
				},
				{
					field: "Расход с текущего по предыдущее",
					value: device.vol + " кВтч",
				},
				{
					field: "Действующий тариф",
					value: device.taxacur,
				},
			];
			detailsData.push(
				{
					serial: device.serial,
					data: dataValueItem,
				}
			);
		}
		let detailsTotal = [
			{
				field: "Начислено",
				value: formatPriceWithSymbol(sumForDevices),
			},
			{
				field: "Начисления по предыдущим показаниям",
				value: formatPriceWithSymbol(sumForPrevValues),
			},
			{
				field: "К оплате",
				value: formatPriceWithSymbol(totalSum),
			},
		];
		return {
			detailsData,
			detailsTotal,
		};
	}

}

export default ContractInfo;